import React from "react";

import { ReactComponent as ErrorImage } from "common/assets/images/errorExclamation.svg";

import { SidebarContentWrapper } from "../SidebarContentWrapper";
import styles from "./SidebarContentError.module.scss";

export default function SidebarContentError() {
  return (
    <SidebarContentWrapper className={styles.wrapper}>
      <ErrorImage />
      <span>Sorry, something went wrong</span>
    </SidebarContentWrapper>
  );
}
